export default {
  name: "InfoDialog",
  data: () => ({
    dialog: false
  }),
  props: [
    "heading", // Required
    "buttonText", // Required
    "infoText", // Required
    "closeText", // Optional
    "icon" // Optional
  ]
};
